import React, { SVGProps } from 'react';

export const IconChevronDown = (props: SVGProps<SVGSVGElement>) => <svg fill="none" viewBox="0 0 32 32" width="1em" height="1em" {...props}><path fill="currentColor" d="m4.65 8.35-2.3 2.3a.5.5 0 0 0 0 .7l13.3 13.3c.2.2.5.2.7 0l13.3-13.3a.5.5 0 0 0 0-.7l-2.3-2.3a.5.5 0 0 0-.7 0l-10.3 10.3a.5.5 0 0 1-.7 0L5.35 8.35a.5.5 0 0 0-.7 0Z"/></svg>;
